<template>
  <v-row class="text-center" justify="space-around" height='90vh' style="margin: 0 0">
    <v-col :cols='[this.$vuetify.breakpoint.smAndDown ? 4 : 2]'>
      <v-row class="text-center" justify="space-around" v-if="this.$vuetify.breakpoint.smAndDown && !this.activeTile.end">
        <v-col cols='12'>
          <v-btn icon color="green" :disabled="!this.activeTile.options.includes('north')" v-on:keyup.38.native="progress('north')" @click="progress('north')">
            <v-icon>mdi-arrow-up-bold</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="text-center" justify="space-around" v-if="this.$vuetify.breakpoint.smAndDown && !this.activeTile.end">
        <v-col cols='6'>
          <v-btn icon color="green" :disabled="!this.activeTile.options.includes('west')" v-on:keyup.37.native="progress('west')" @click="progress('west')">
            <v-icon>mdi-arrow-left-bold</v-icon>
          </v-btn>
        </v-col>
        <v-col cols='6'>
          <v-btn icon color="green" :disabled="!this.activeTile.options.includes('east')" v-on:keyup.39.native="progress('east')" @click="progress('east')">
            <v-icon>mdi-arrow-right-bold</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="text-center" justify="space-around" v-if="this.$vuetify.breakpoint.smAndDown && !this.activeTile.end">
        <v-col cols='12'>
          <v-btn icon color="green" :disabled="!this.activeTile.options.includes('south')" v-on:keyup.40.native="progress('south')" @click="progress('south')">
            <v-icon>mdi-arrow-down-bold</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="text-center" justify="space-around" v-if="this.$vuetify.breakpoint.smAndDown && this.activeTile.end">
          <v-col cols='12'>
            <v-btn icon color="green" @click="reset()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      <v-row>
        Masculinity:
        <v-progress-linear
        v-model="masculinity"
        color="green"
        height="25"
        ></v-progress-linear>
      </v-row>
      <v-row>
        Transformation Duration:
        <v-progress-linear
        v-model="transformationPercentage"
        color="pink"
        height="25"
        ></v-progress-linear>
      </v-row>
      <v-row>
        Research Compensation: ${{compensation}}
      </v-row>
      <v-row>
          <table style="width:100%">
              <tr>
                <td :class="[tileHistory.includes('A1') ? searchedTileClass : '', activeTile.Id == 'A1' ? activeTileClass : '', simpleTileHistory.includes('A1') ? searchedSimpleTileClass : '', endTileHistory.includes('A1') ? searchedEndTileClass : '',]" @click="jump('A1')" id="A1" ref="A1"></td>
                <td :class="[tileHistory.includes('B1') ? searchedTileClass : '', activeTile.Id == 'B1' ? activeTileClass : '', simpleTileHistory.includes('B1') ? searchedSimpleTileClass : '', endTileHistory.includes('B1') ? searchedEndTileClass : '',]" @click="jump('B1')" id="B1" ref="B1"></td>
                <td :class="[tileHistory.includes('C1') ? searchedTileClass : '', activeTile.Id == 'C1' ? activeTileClass : '', simpleTileHistory.includes('C1') ? searchedSimpleTileClass : '', endTileHistory.includes('C1') ? searchedEndTileClass : '',]" @click="jump('C1')" id="C1" ref="C1"></td>
                <td :class="[tileHistory.includes('D1') ? searchedTileClass : '', activeTile.Id == 'D1' ? activeTileClass : '', simpleTileHistory.includes('D1') ? searchedSimpleTileClass : '', endTileHistory.includes('D1') ? searchedEndTileClass : '',]" @click="jump('D1')" id="D1" ref="D1"></td>
                <td :class="[tileHistory.includes('E1') ? searchedTileClass : '', activeTile.Id == 'E1' ? activeTileClass : '', simpleTileHistory.includes('E1') ? searchedSimpleTileClass : '', endTileHistory.includes('E1') ? searchedEndTileClass : '',]" @click="jump('E1')" id="E1" ref="E1"></td>
                <td :class="[tileHistory.includes('F1') ? searchedTileClass : '', activeTile.Id == 'F1' ? activeTileClass : '', simpleTileHistory.includes('F1') ? searchedSimpleTileClass : '', endTileHistory.includes('F1') ? searchedEndTileClass : '',]" @click="jump('F1')" id="F1" ref="F1"></td>
                <td :class="[tileHistory.includes('G1') ? searchedTileClass : '', activeTile.Id == 'G1' ? activeTileClass : '', simpleTileHistory.includes('G1') ? searchedSimpleTileClass : '', endTileHistory.includes('G1') ? searchedEndTileClass : '',]" @click="jump('G1')" id="G1" ref="G1"></td>
                <td :class="[tileHistory.includes('H1') ? searchedTileClass : '', activeTile.Id == 'H1' ? activeTileClass : '', simpleTileHistory.includes('H1') ? searchedSimpleTileClass : '', endTileHistory.includes('H1') ? searchedEndTileClass : '',]" @click="jump('H1')" id="H1" ref="H1"></td>
                <td :class="[tileHistory.includes('I1') ? searchedTileClass : '', activeTile.Id == 'I1' ? activeTileClass : '', simpleTileHistory.includes('I1') ? searchedSimpleTileClass : '', endTileHistory.includes('I1') ? searchedEndTileClass : '',]" @click="jump('I1')" id="I1" ref="I1"></td>
                <td :class="[tileHistory.includes('J1') ? searchedTileClass : '', activeTile.Id == 'J1' ? activeTileClass : '', simpleTileHistory.includes('J1') ? searchedSimpleTileClass : '', endTileHistory.includes('J1') ? searchedEndTileClass : '',]" @click="jump('J1')" id="J1" ref="J1"></td>
                <td :class="[tileHistory.includes('K1') ? searchedTileClass : '', activeTile.Id == 'K1' ? activeTileClass : '', simpleTileHistory.includes('K1') ? searchedSimpleTileClass : '', endTileHistory.includes('K1') ? searchedEndTileClass : '',]" @click="jump('K1')" id="K1" ref="K1"></td>
              </tr>
              <tr>
                <td :class="[tileHistory.includes('A2') ? searchedTileClass : '', activeTile.Id == 'A2' ? activeTileClass : '', simpleTileHistory.includes('A2') ? searchedSimpleTileClass : '', endTileHistory.includes('A2') ? searchedEndTileClass : '',]" @click="jump('A2')" id="A2" ref="A2"></td>
                <td :class="[tileHistory.includes('B2') ? searchedTileClass : '', activeTile.Id == 'B2' ? activeTileClass : '', simpleTileHistory.includes('B2') ? searchedSimpleTileClass : '', endTileHistory.includes('B2') ? searchedEndTileClass : '',]" @click="jump('B2')" id="B2" ref="B2"></td>
                <td :class="[tileHistory.includes('C2') ? searchedTileClass : '', activeTile.Id == 'C2' ? activeTileClass : '', simpleTileHistory.includes('C2') ? searchedSimpleTileClass : '', endTileHistory.includes('C2') ? searchedEndTileClass : '',]" @click="jump('C2')" id="C2" ref="C2"></td>
                <td :class="[tileHistory.includes('D2') ? searchedTileClass : '', activeTile.Id == 'D2' ? activeTileClass : '', simpleTileHistory.includes('D2') ? searchedSimpleTileClass : '', endTileHistory.includes('D2') ? searchedEndTileClass : '',]" @click="jump('D2')" id="D2" ref="D2"></td>
                <td :class="[tileHistory.includes('E2') ? searchedTileClass : '', activeTile.Id == 'E2' ? activeTileClass : '', simpleTileHistory.includes('E2') ? searchedSimpleTileClass : '', endTileHistory.includes('E2') ? searchedEndTileClass : '',]" @click="jump('E2')" id="E2" ref="E2"></td>
                <td :class="[tileHistory.includes('F2') ? searchedTileClass : '', activeTile.Id == 'F2' ? activeTileClass : '', simpleTileHistory.includes('F2') ? searchedSimpleTileClass : '', endTileHistory.includes('F2') ? searchedEndTileClass : '',]" @click="jump('F2')" id="F2" ref="F2"></td>
                <td :class="[tileHistory.includes('G2') ? searchedTileClass : '', activeTile.Id == 'G2' ? activeTileClass : '', simpleTileHistory.includes('G2') ? searchedSimpleTileClass : '', endTileHistory.includes('G2') ? searchedEndTileClass : '',]" @click="jump('G2')" id="G2" ref="G2"></td>
                <td :class="[tileHistory.includes('H2') ? searchedTileClass : '', activeTile.Id == 'H2' ? activeTileClass : '', simpleTileHistory.includes('H2') ? searchedSimpleTileClass : '', endTileHistory.includes('H2') ? searchedEndTileClass : '',]" @click="jump('H2')" id="H2" ref="H2"></td>
                <td :class="[tileHistory.includes('I2') ? searchedTileClass : '', activeTile.Id == 'I2' ? activeTileClass : '', simpleTileHistory.includes('I2') ? searchedSimpleTileClass : '', endTileHistory.includes('I2') ? searchedEndTileClass : '',]" @click="jump('I2')" id="I2" ref="I2"></td>
                <td :class="[tileHistory.includes('J2') ? searchedTileClass : '', activeTile.Id == 'J2' ? activeTileClass : '', simpleTileHistory.includes('J2') ? searchedSimpleTileClass : '', endTileHistory.includes('J2') ? searchedEndTileClass : '',]" @click="jump('J2')" id="J2" ref="J2"></td>
                <td :class="[tileHistory.includes('K2') ? searchedTileClass : '', activeTile.Id == 'K2' ? activeTileClass : '', simpleTileHistory.includes('K2') ? searchedSimpleTileClass : '', endTileHistory.includes('K2') ? searchedEndTileClass : '',]" @click="jump('K2')" id="K2" ref="K2"></td>
              </tr>
              <tr>
                <td :class="[tileHistory.includes('A3') ? searchedTileClass : '', activeTile.Id == 'A3' ? activeTileClass : '', simpleTileHistory.includes('A3') ? searchedSimpleTileClass : '', endTileHistory.includes('A3') ? searchedEndTileClass : '',]" @click="jump('A3')" id="A3" ref="A3"></td>
                <td :class="[tileHistory.includes('B3') ? searchedTileClass : '', activeTile.Id == 'B3' ? activeTileClass : '', simpleTileHistory.includes('B3') ? searchedSimpleTileClass : '', endTileHistory.includes('B3') ? searchedEndTileClass : '',]" @click="jump('B3')" id="B3" ref="B3"></td>
                <td :class="[tileHistory.includes('C3') ? searchedTileClass : '', activeTile.Id == 'C3' ? activeTileClass : '', simpleTileHistory.includes('C3') ? searchedSimpleTileClass : '', endTileHistory.includes('C3') ? searchedEndTileClass : '',]" @click="jump('C3')" id="C3" ref="C3"></td>
                <td :class="[tileHistory.includes('D3') ? searchedTileClass : '', activeTile.Id == 'D3' ? activeTileClass : '', simpleTileHistory.includes('D3') ? searchedSimpleTileClass : '', endTileHistory.includes('D3') ? searchedEndTileClass : '',]" @click="jump('D3')" id="D3" ref="D3"></td>
                <td :class="[tileHistory.includes('E3') ? searchedTileClass : '', activeTile.Id == 'E3' ? activeTileClass : '', simpleTileHistory.includes('E3') ? searchedSimpleTileClass : '', endTileHistory.includes('E3') ? searchedEndTileClass : '',]" @click="jump('E3')" id="E3" ref="E3"></td>
                <td :class="[tileHistory.includes('F3') ? searchedTileClass : '', activeTile.Id == 'F3' ? activeTileClass : '', simpleTileHistory.includes('F3') ? searchedSimpleTileClass : '', endTileHistory.includes('F3') ? searchedEndTileClass : '',]" @click="jump('F3')" id="F3" ref="F3"></td>
                <td :class="[tileHistory.includes('G3') ? searchedTileClass : '', activeTile.Id == 'G3' ? activeTileClass : '', simpleTileHistory.includes('G3') ? searchedSimpleTileClass : '', endTileHistory.includes('G3') ? searchedEndTileClass : '',]" @click="jump('G3')" id="G3" ref="G3"></td>
                <td :class="[tileHistory.includes('H3') ? searchedTileClass : '', activeTile.Id == 'H3' ? activeTileClass : '', simpleTileHistory.includes('H3') ? searchedSimpleTileClass : '', endTileHistory.includes('H3') ? searchedEndTileClass : '',]" @click="jump('H3')" id="H3" ref="H3"></td>
                <td :class="[tileHistory.includes('I3') ? searchedTileClass : '', activeTile.Id == 'I3' ? activeTileClass : '', simpleTileHistory.includes('I3') ? searchedSimpleTileClass : '', endTileHistory.includes('I3') ? searchedEndTileClass : '',]" @click="jump('I3')" id="I3" ref="I3"></td>
                <td :class="[tileHistory.includes('J3') ? searchedTileClass : '', activeTile.Id == 'J3' ? activeTileClass : '', simpleTileHistory.includes('J3') ? searchedSimpleTileClass : '', endTileHistory.includes('J3') ? searchedEndTileClass : '',]" @click="jump('J3')" id="J3" ref="J3"></td>
                <td :class="[tileHistory.includes('K3') ? searchedTileClass : '', activeTile.Id == 'K3' ? activeTileClass : '', simpleTileHistory.includes('K3') ? searchedSimpleTileClass : '', endTileHistory.includes('K3') ? searchedEndTileClass : '',]" @click="jump('K3')" id="K3" ref="K3"></td>
              </tr>
              <tr>
                <td :class="[tileHistory.includes('A4') ? searchedTileClass : '', activeTile.Id == 'A4' ? activeTileClass : '', simpleTileHistory.includes('A4') ? searchedSimpleTileClass : '', endTileHistory.includes('A4') ? searchedEndTileClass : '',]" @click="jump('A4')" id="A4" ref="A4"></td>
                <td :class="[tileHistory.includes('B4') ? searchedTileClass : '', activeTile.Id == 'B4' ? activeTileClass : '', simpleTileHistory.includes('B4') ? searchedSimpleTileClass : '', endTileHistory.includes('B4') ? searchedEndTileClass : '',]" @click="jump('B4')" id="B4" ref="B4"></td>
                <td :class="[tileHistory.includes('C4') ? searchedTileClass : '', activeTile.Id == 'C4' ? activeTileClass : '', simpleTileHistory.includes('C4') ? searchedSimpleTileClass : '', endTileHistory.includes('C4') ? searchedEndTileClass : '',]" @click="jump('C4')" id="C4" ref="C4"></td>
                <td :class="[tileHistory.includes('D4') ? searchedTileClass : '', activeTile.Id == 'D4' ? activeTileClass : '', simpleTileHistory.includes('D4') ? searchedSimpleTileClass : '', endTileHistory.includes('D4') ? searchedEndTileClass : '',]" @click="jump('D4')" id="D4" ref="D4"></td>
                <td :class="[tileHistory.includes('E4') ? searchedTileClass : '', activeTile.Id == 'E4' ? activeTileClass : '', simpleTileHistory.includes('E4') ? searchedSimpleTileClass : '', endTileHistory.includes('E4') ? searchedEndTileClass : '',]" @click="jump('E4')" id="E4" ref="E4"></td>
                <td :class="[tileHistory.includes('F4') ? searchedTileClass : '', activeTile.Id == 'F4' ? activeTileClass : '', simpleTileHistory.includes('F4') ? searchedSimpleTileClass : '', endTileHistory.includes('F4') ? searchedEndTileClass : '',]" @click="jump('F4')" id="F4" ref="F4"></td>
                <td :class="[tileHistory.includes('G4') ? searchedTileClass : '', activeTile.Id == 'G4' ? activeTileClass : '', simpleTileHistory.includes('G4') ? searchedSimpleTileClass : '', endTileHistory.includes('G4') ? searchedEndTileClass : '',]" @click="jump('G4')" id="G4" ref="G4"></td>
                <td :class="[tileHistory.includes('H4') ? searchedTileClass : '', activeTile.Id == 'H4' ? activeTileClass : '', simpleTileHistory.includes('H4') ? searchedSimpleTileClass : '', endTileHistory.includes('H4') ? searchedEndTileClass : '',]" @click="jump('H4')" id="H4" ref="H4"></td>
                <td :class="[tileHistory.includes('I4') ? searchedTileClass : '', activeTile.Id == 'I4' ? activeTileClass : '', simpleTileHistory.includes('I4') ? searchedSimpleTileClass : '', endTileHistory.includes('I4') ? searchedEndTileClass : '',]" @click="jump('I4')" id="I4" ref="I4"></td>
                <td :class="[tileHistory.includes('J4') ? searchedTileClass : '', activeTile.Id == 'J4' ? activeTileClass : '', simpleTileHistory.includes('J4') ? searchedSimpleTileClass : '', endTileHistory.includes('J4') ? searchedEndTileClass : '',]" @click="jump('J4')" id="J4" ref="J4"></td>
                <td :class="[tileHistory.includes('K4') ? searchedTileClass : '', activeTile.Id == 'K4' ? activeTileClass : '', simpleTileHistory.includes('K4') ? searchedSimpleTileClass : '', endTileHistory.includes('K4') ? searchedEndTileClass : '',]" @click="jump('K4')" id="K4" ref="K4"></td>
              </tr>
              <tr>
                <td :class="[tileHistory.includes('A5') ? searchedTileClass : '', activeTile.Id == 'A5' ? activeTileClass : '', simpleTileHistory.includes('A5') ? searchedSimpleTileClass : '', endTileHistory.includes('A5') ? searchedEndTileClass : '',]" @click="jump('A5')" id="A5" ref="A5"></td>
                <td :class="[tileHistory.includes('B5') ? searchedTileClass : '', activeTile.Id == 'B5' ? activeTileClass : '', simpleTileHistory.includes('B5') ? searchedSimpleTileClass : '', endTileHistory.includes('B5') ? searchedEndTileClass : '',]" @click="jump('B5')" id="B5" ref="B5"></td>
                <td :class="[tileHistory.includes('C5') ? searchedTileClass : '', activeTile.Id == 'C5' ? activeTileClass : '', simpleTileHistory.includes('C5') ? searchedSimpleTileClass : '', endTileHistory.includes('C5') ? searchedEndTileClass : '',]" @click="jump('C5')" id="C5" ref="C5"></td>
                <td :class="[tileHistory.includes('D5') ? searchedTileClass : '', activeTile.Id == 'D5' ? activeTileClass : '', simpleTileHistory.includes('D5') ? searchedSimpleTileClass : '', endTileHistory.includes('D5') ? searchedEndTileClass : '',]" @click="jump('D5')" id="D5" ref="D5"></td>
                <td :class="[tileHistory.includes('E5') ? searchedTileClass : '', activeTile.Id == 'E5' ? activeTileClass : '', simpleTileHistory.includes('E5') ? searchedSimpleTileClass : '', endTileHistory.includes('E5') ? searchedEndTileClass : '',]" @click="jump('E5')" id="E5" ref="E5"></td>
                <td :class="[tileHistory.includes('F5') ? searchedTileClass : '', activeTile.Id == 'F5' ? activeTileClass : '', simpleTileHistory.includes('F5') ? searchedSimpleTileClass : '', endTileHistory.includes('F5') ? searchedEndTileClass : '',]" @click="jump('F5')" id="F5" ref="F5"></td>
                <td :class="[tileHistory.includes('G5') ? searchedTileClass : '', activeTile.Id == 'G5' ? activeTileClass : '', simpleTileHistory.includes('G5') ? searchedSimpleTileClass : '', endTileHistory.includes('G5') ? searchedEndTileClass : '',]" @click="jump('G5')" id="G5" ref="G5"></td>
                <td :class="[tileHistory.includes('H5') ? searchedTileClass : '', activeTile.Id == 'H5' ? activeTileClass : '', simpleTileHistory.includes('H5') ? searchedSimpleTileClass : '', endTileHistory.includes('H5') ? searchedEndTileClass : '',]" @click="jump('H5')" id="H5" ref="H5"></td>
                <td :class="[tileHistory.includes('I5') ? searchedTileClass : '', activeTile.Id == 'I5' ? activeTileClass : '', simpleTileHistory.includes('I5') ? searchedSimpleTileClass : '', endTileHistory.includes('I5') ? searchedEndTileClass : '',]" @click="jump('I5')" id="I5" ref="I5"></td>
                <td :class="[tileHistory.includes('J5') ? searchedTileClass : '', activeTile.Id == 'J5' ? activeTileClass : '', simpleTileHistory.includes('J5') ? searchedSimpleTileClass : '', endTileHistory.includes('J5') ? searchedEndTileClass : '',]" @click="jump('J5')" id="J5" ref="J5"></td>
                <td :class="[tileHistory.includes('K5') ? searchedTileClass : '', activeTile.Id == 'K5' ? activeTileClass : '', simpleTileHistory.includes('K5') ? searchedSimpleTileClass : '', endTileHistory.includes('K5') ? searchedEndTileClass : '',]" @click="jump('K5')" id="K5" ref="K5"></td>
              </tr>
              <tr>
                <td :class="[tileHistory.includes('A6') ? searchedTileClass : '', activeTile.Id == 'A6' ? activeTileClass : '', simpleTileHistory.includes('A6') ? searchedSimpleTileClass : '', endTileHistory.includes('A6') ? searchedEndTileClass : '',]" @click="jump('A6')" id="A6" ref="A6"></td>
                <td :class="[tileHistory.includes('B6') ? searchedTileClass : '', activeTile.Id == 'B6' ? activeTileClass : '', simpleTileHistory.includes('B6') ? searchedSimpleTileClass : '', endTileHistory.includes('B6') ? searchedEndTileClass : '',]" @click="jump('B6')" id="B6" ref="B6"></td>
                <td :class="[tileHistory.includes('C6') ? searchedTileClass : '', activeTile.Id == 'C6' ? activeTileClass : '', simpleTileHistory.includes('C6') ? searchedSimpleTileClass : '', endTileHistory.includes('C6') ? searchedEndTileClass : '',]" @click="jump('C6')" id="C6" ref="C6"></td>
                <td :class="[tileHistory.includes('D6') ? searchedTileClass : '', activeTile.Id == 'D6' ? activeTileClass : '', simpleTileHistory.includes('D6') ? searchedSimpleTileClass : '', endTileHistory.includes('D6') ? searchedEndTileClass : '',]" @click="jump('D6')" id="D6" ref="D6"></td>
                <td :class="[tileHistory.includes('E6') ? searchedTileClass : '', activeTile.Id == 'E6' ? activeTileClass : '', simpleTileHistory.includes('E6') ? searchedSimpleTileClass : '', endTileHistory.includes('E6') ? searchedEndTileClass : '',]" @click="jump('E6')" id="E6" ref="E6"></td>
                <td :class="[tileHistory.includes('F6') ? searchedTileClass : '', activeTile.Id == 'F6' ? activeTileClass : '', simpleTileHistory.includes('F6') ? searchedSimpleTileClass : '', endTileHistory.includes('F6') ? searchedEndTileClass : '',]" @click="jump('F6')" id="F6" ref="F6"></td>
                <td :class="[tileHistory.includes('G6') ? searchedTileClass : '', activeTile.Id == 'G6' ? activeTileClass : '', simpleTileHistory.includes('G6') ? searchedSimpleTileClass : '', endTileHistory.includes('G6') ? searchedEndTileClass : '',]" @click="jump('G6')" id="G6" ref="G6"></td>
                <td :class="[tileHistory.includes('H6') ? searchedTileClass : '', activeTile.Id == 'H6' ? activeTileClass : '', simpleTileHistory.includes('H6') ? searchedSimpleTileClass : '', endTileHistory.includes('H6') ? searchedEndTileClass : '',]" @click="jump('H6')" id="H6" ref="H6"></td>
                <td :class="[tileHistory.includes('I6') ? searchedTileClass : '', activeTile.Id == 'I6' ? activeTileClass : '', simpleTileHistory.includes('I6') ? searchedSimpleTileClass : '', endTileHistory.includes('I6') ? searchedEndTileClass : '',]" @click="jump('I6')" id="I6" ref="I6"></td>
                <td :class="[tileHistory.includes('J6') ? searchedTileClass : '', activeTile.Id == 'J6' ? activeTileClass : '', simpleTileHistory.includes('J6') ? searchedSimpleTileClass : '', endTileHistory.includes('J6') ? searchedEndTileClass : '',]" @click="jump('J6')" id="J6" ref="J6"></td>
                <td :class="[tileHistory.includes('K6') ? searchedTileClass : '', activeTile.Id == 'K6' ? activeTileClass : '', simpleTileHistory.includes('K6') ? searchedSimpleTileClass : '', endTileHistory.includes('K6') ? searchedEndTileClass : '',]" @click="jump('K6')" id="K6" ref="K6"></td>
              </tr>
              <tr>
                <td :class="[tileHistory.includes('A7') ? searchedTileClass : '', activeTile.Id == 'A7' ? activeTileClass : '', simpleTileHistory.includes('A7') ? searchedSimpleTileClass : '', endTileHistory.includes('A7') ? searchedEndTileClass : '',]" @click="jump('A7')" id="A7" ref="A7"></td>
                <td :class="[tileHistory.includes('B7') ? searchedTileClass : '', activeTile.Id == 'B7' ? activeTileClass : '', simpleTileHistory.includes('B7') ? searchedSimpleTileClass : '', endTileHistory.includes('B7') ? searchedEndTileClass : '',]" @click="jump('B7')" id="B7" ref="B7"></td>
                <td :class="[tileHistory.includes('C7') ? searchedTileClass : '', activeTile.Id == 'C7' ? activeTileClass : '', simpleTileHistory.includes('C7') ? searchedSimpleTileClass : '', endTileHistory.includes('C7') ? searchedEndTileClass : '',]" @click="jump('C7')" id="C7" ref="C7"></td>
                <td :class="[tileHistory.includes('D7') ? searchedTileClass : '', activeTile.Id == 'D7' ? activeTileClass : '', simpleTileHistory.includes('D7') ? searchedSimpleTileClass : '', endTileHistory.includes('D7') ? searchedEndTileClass : '',]" @click="jump('D7')" id="D7" ref="D7"></td>
                <td :class="[tileHistory.includes('E7') ? searchedTileClass : '', activeTile.Id == 'E7' ? activeTileClass : '', simpleTileHistory.includes('E7') ? searchedSimpleTileClass : '', endTileHistory.includes('E7') ? searchedEndTileClass : '',]" @click="jump('E7')" id="E7" ref="E7"></td>
                <td :class="[tileHistory.includes('F7') ? searchedTileClass : '', activeTile.Id == 'F7' ? activeTileClass : '', simpleTileHistory.includes('F7') ? searchedSimpleTileClass : '', endTileHistory.includes('F7') ? searchedEndTileClass : '',]" @click="jump('F7')" id="F7" ref="F7"></td>
                <td :class="[tileHistory.includes('G7') ? searchedTileClass : '', activeTile.Id == 'G7' ? activeTileClass : '', simpleTileHistory.includes('G7') ? searchedSimpleTileClass : '', endTileHistory.includes('G7') ? searchedEndTileClass : '',]" @click="jump('G7')" id="G7" ref="G7"></td>
                <td :class="[tileHistory.includes('H7') ? searchedTileClass : '', activeTile.Id == 'H7' ? activeTileClass : '', simpleTileHistory.includes('H7') ? searchedSimpleTileClass : '', endTileHistory.includes('H7') ? searchedEndTileClass : '',]" @click="jump('H7')" id="H7" ref="H7"></td>
                <td :class="[tileHistory.includes('I7') ? searchedTileClass : '', activeTile.Id == 'I7' ? activeTileClass : '', simpleTileHistory.includes('I7') ? searchedSimpleTileClass : '', endTileHistory.includes('I7') ? searchedEndTileClass : '',]" @click="jump('I7')" id="I7" ref="I7"></td>
                <td :class="[tileHistory.includes('J7') ? searchedTileClass : '', activeTile.Id == 'J7' ? activeTileClass : '', simpleTileHistory.includes('J7') ? searchedSimpleTileClass : '', endTileHistory.includes('J7') ? searchedEndTileClass : '',]" @click="jump('J7')" id="J7" ref="J7"></td>
                <td :class="[tileHistory.includes('K7') ? searchedTileClass : '', activeTile.Id == 'K7' ? activeTileClass : '', simpleTileHistory.includes('K7') ? searchedSimpleTileClass : '', endTileHistory.includes('K7') ? searchedEndTileClass : '',]" @click="jump('K7')" id="K7" ref="K7"></td>
              </tr>
              <tr>
                <td :class="[tileHistory.includes('A8') ? searchedTileClass : '', activeTile.Id == 'A8' ? activeTileClass : '', simpleTileHistory.includes('A8') ? searchedSimpleTileClass : '', endTileHistory.includes('A8') ? searchedEndTileClass : '',]" @click="jump('A8')" id="A8" ref="A8"></td>
                <td :class="[tileHistory.includes('B8') ? searchedTileClass : '', activeTile.Id == 'B8' ? activeTileClass : '', simpleTileHistory.includes('B8') ? searchedSimpleTileClass : '', endTileHistory.includes('B8') ? searchedEndTileClass : '',]" @click="jump('B8')" id="B8" ref="B8"></td>
                <td :class="[tileHistory.includes('C8') ? searchedTileClass : '', activeTile.Id == 'C8' ? activeTileClass : '', simpleTileHistory.includes('C8') ? searchedSimpleTileClass : '', endTileHistory.includes('C8') ? searchedEndTileClass : '',]" @click="jump('C8')" id="C8" ref="C8"></td>
                <td :class="[tileHistory.includes('D8') ? searchedTileClass : '', activeTile.Id == 'D8' ? activeTileClass : '', simpleTileHistory.includes('D8') ? searchedSimpleTileClass : '', endTileHistory.includes('D8') ? searchedEndTileClass : '',]" @click="jump('D8')" id="D8" ref="D8"></td>
                <td :class="[tileHistory.includes('E8') ? searchedTileClass : '', activeTile.Id == 'E8' ? activeTileClass : '', simpleTileHistory.includes('E8') ? searchedSimpleTileClass : '', endTileHistory.includes('E8') ? searchedEndTileClass : '',]" @click="jump('E8')" id="E8" ref="E8"></td>
                <td :class="[tileHistory.includes('F8') ? searchedTileClass : '', activeTile.Id == 'F8' ? activeTileClass : '', simpleTileHistory.includes('F8') ? searchedSimpleTileClass : '', endTileHistory.includes('F8') ? searchedEndTileClass : '',]" @click="jump('F8')" id="F8" ref="F8"></td>
                <td :class="[tileHistory.includes('G8') ? searchedTileClass : '', activeTile.Id == 'G8' ? activeTileClass : '', simpleTileHistory.includes('G8') ? searchedSimpleTileClass : '', endTileHistory.includes('G8') ? searchedEndTileClass : '',]" @click="jump('G8')" id="G8" ref="G8"></td>
                <td :class="[tileHistory.includes('H8') ? searchedTileClass : '', activeTile.Id == 'H8' ? activeTileClass : '', simpleTileHistory.includes('H8') ? searchedSimpleTileClass : '', endTileHistory.includes('H8') ? searchedEndTileClass : '',]" @click="jump('H8')" id="H8" ref="H8"></td>
                <td :class="[tileHistory.includes('I8') ? searchedTileClass : '', activeTile.Id == 'I8' ? activeTileClass : '', simpleTileHistory.includes('I8') ? searchedSimpleTileClass : '', endTileHistory.includes('I8') ? searchedEndTileClass : '',]" @click="jump('I8')" id="I8" ref="I8"></td>
                <td :class="[tileHistory.includes('J8') ? searchedTileClass : '', activeTile.Id == 'J8' ? activeTileClass : '', simpleTileHistory.includes('J8') ? searchedSimpleTileClass : '', endTileHistory.includes('J8') ? searchedEndTileClass : '',]" @click="jump('J8')" id="J8" ref="J8"></td>
                <td :class="[tileHistory.includes('K8') ? searchedTileClass : '', activeTile.Id == 'K8' ? activeTileClass : '', simpleTileHistory.includes('K8') ? searchedSimpleTileClass : '', endTileHistory.includes('K8') ? searchedEndTileClass : '',]" @click="jump('K8')" id="K8" ref="K8"></td>
              </tr>
              <tr>
                <td :class="[tileHistory.includes('A9') ? searchedTileClass : '', activeTile.Id == 'A9' ? activeTileClass : '', simpleTileHistory.includes('A9') ? searchedSimpleTileClass : '', endTileHistory.includes('A9') ? searchedEndTileClass : '',]" @click="jump('A9')" id="A9" ref="A9"></td>
                <td :class="[tileHistory.includes('B9') ? searchedTileClass : '', activeTile.Id == 'B9' ? activeTileClass : '', simpleTileHistory.includes('B9') ? searchedSimpleTileClass : '', endTileHistory.includes('B9') ? searchedEndTileClass : '',]" @click="jump('B9')" id="B9" ref="B9"></td>
                <td :class="[tileHistory.includes('C9') ? searchedTileClass : '', activeTile.Id == 'C9' ? activeTileClass : '', simpleTileHistory.includes('C9') ? searchedSimpleTileClass : '', endTileHistory.includes('C9') ? searchedEndTileClass : '',]" @click="jump('C9')" id="C9" ref="C9"></td>
                <td :class="[tileHistory.includes('D9') ? searchedTileClass : '', activeTile.Id == 'D9' ? activeTileClass : '', simpleTileHistory.includes('D9') ? searchedSimpleTileClass : '', endTileHistory.includes('D9') ? searchedEndTileClass : '',]" @click="jump('D9')" id="D9" ref="D9"></td>
                <td :class="[tileHistory.includes('E9') ? searchedTileClass : '', activeTile.Id == 'E9' ? activeTileClass : '', simpleTileHistory.includes('E9') ? searchedSimpleTileClass : '', endTileHistory.includes('E9') ? searchedEndTileClass : '',]" @click="jump('E9')" id="E9" ref="E9"></td>
                <td :class="[tileHistory.includes('F9') ? searchedTileClass : '', activeTile.Id == 'F9' ? activeTileClass : '', simpleTileHistory.includes('F9') ? searchedSimpleTileClass : '', endTileHistory.includes('F9') ? searchedEndTileClass : '',]" @click="jump('F9')" id="F9" ref="F9"></td>
                <td :class="[tileHistory.includes('G9') ? searchedTileClass : '', activeTile.Id == 'G9' ? activeTileClass : '', simpleTileHistory.includes('G9') ? searchedSimpleTileClass : '', endTileHistory.includes('G9') ? searchedEndTileClass : '',]" @click="jump('G9')" id="G9" ref="G9"></td>
                <td :class="[tileHistory.includes('H9') ? searchedTileClass : '', activeTile.Id == 'H9' ? activeTileClass : '', simpleTileHistory.includes('H9') ? searchedSimpleTileClass : '', endTileHistory.includes('H9') ? searchedEndTileClass : '',]" @click="jump('H9')" id="H9" ref="H9"></td>
                <td :class="[tileHistory.includes('I9') ? searchedTileClass : '', activeTile.Id == 'I9' ? activeTileClass : '', simpleTileHistory.includes('I9') ? searchedSimpleTileClass : '', endTileHistory.includes('I9') ? searchedEndTileClass : '',]" @click="jump('I9')" id="I9" ref="I9"></td>
                <td :class="[tileHistory.includes('J9') ? searchedTileClass : '', activeTile.Id == 'J9' ? activeTileClass : '', simpleTileHistory.includes('J9') ? searchedSimpleTileClass : '', endTileHistory.includes('J9') ? searchedEndTileClass : '',]" @click="jump('J9')" id="J9" ref="J9"></td>
                <td :class="[tileHistory.includes('K9') ? searchedTileClass : '', activeTile.Id == 'K9' ? activeTileClass : '', simpleTileHistory.includes('K9') ? searchedSimpleTileClass : '', endTileHistory.includes('K9') ? searchedEndTileClass : '',]" @click="jump('K9')" id="K9" ref="K9"></td>
              </tr>
              <tr>
                <td :class="[tileHistory.includes('A10') ? searchedTileClass : '', activeTile.Id == 'A10' ? activeTileClass : '', simpleTileHistory.includes('A10') ? searchedSimpleTileClass : '', endTileHistory.includes('A10') ? searchedEndTileClass : '',]" @click="jump('A10')" id="A10" ref="A10"></td>
                <td :class="[tileHistory.includes('B10') ? searchedTileClass : '', activeTile.Id == 'B10' ? activeTileClass : '', simpleTileHistory.includes('B10') ? searchedSimpleTileClass : '', endTileHistory.includes('B10') ? searchedEndTileClass : '',]" @click="jump('B10')" id="B10" ref="B10"></td>
                <td :class="[tileHistory.includes('C10') ? searchedTileClass : '', activeTile.Id == 'C10' ? activeTileClass : '', simpleTileHistory.includes('C10') ? searchedSimpleTileClass : '', endTileHistory.includes('C10') ? searchedEndTileClass : '',]" @click="jump('C10')" id="C10" ref="C10"></td>
                <td :class="[tileHistory.includes('D10') ? searchedTileClass : '', activeTile.Id == 'D10' ? activeTileClass : '', simpleTileHistory.includes('D10') ? searchedSimpleTileClass : '', endTileHistory.includes('D10') ? searchedEndTileClass : '',]" @click="jump('D10')" id="D10" ref="D10"></td>
                <td :class="[tileHistory.includes('E10') ? searchedTileClass : '', activeTile.Id == 'E10' ? activeTileClass : '', simpleTileHistory.includes('E10') ? searchedSimpleTileClass : '', endTileHistory.includes('E10') ? searchedEndTileClass : '',]" @click="jump('E10')" id="E10" ref="E10"></td>
                <td :class="[tileHistory.includes('F10') ? searchedTileClass : '', activeTile.Id == 'F10' ? activeTileClass : '', simpleTileHistory.includes('F10') ? searchedSimpleTileClass : '', endTileHistory.includes('F10') ? searchedEndTileClass : '',]" @click="jump('F10')" id="F10" ref="F10"></td>
                <td :class="[tileHistory.includes('G10') ? searchedTileClass : '', activeTile.Id == 'G10' ? activeTileClass : '', simpleTileHistory.includes('G10') ? searchedSimpleTileClass : '', endTileHistory.includes('G10') ? searchedEndTileClass : '',]" @click="jump('G10')" id="G10" ref="G10"></td>
                <td :class="[tileHistory.includes('H10') ? searchedTileClass : '', activeTile.Id == 'H10' ? activeTileClass : '', simpleTileHistory.includes('H10') ? searchedSimpleTileClass : '', endTileHistory.includes('H10') ? searchedEndTileClass : '',]" @click="jump('H10')" id="H10" ref="H10"></td>
                <td :class="[tileHistory.includes('I10') ? searchedTileClass : '', activeTile.Id == 'I10' ? activeTileClass : '', simpleTileHistory.includes('I10') ? searchedSimpleTileClass : '', endTileHistory.includes('I10') ? searchedEndTileClass : '',]" @click="jump('I10')" id="I10" ref="I10"></td>
                <td :class="[tileHistory.includes('J10') ? searchedTileClass : '', activeTile.Id == 'J10' ? activeTileClass : '', simpleTileHistory.includes('J10') ? searchedSimpleTileClass : '', endTileHistory.includes('J10') ? searchedEndTileClass : '',]" @click="jump('J10')" id="J10" ref="J10"></td>
                <td :class="[tileHistory.includes('K10') ? searchedTileClass : '', activeTile.Id == 'K10' ? activeTileClass : '', simpleTileHistory.includes('K10') ? searchedSimpleTileClass : '', endTileHistory.includes('K10') ? searchedEndTileClass : '',]" @click="jump('K10')" id="K10" ref="K10"></td>
              </tr>
              <tr>
                <td :class="[tileHistory.includes('A11') ? searchedTileClass : '', activeTile.Id == 'A11' ? activeTileClass : '', simpleTileHistory.includes('A11') ? searchedSimpleTileClass : '', endTileHistory.includes('A11') ? searchedEndTileClass : '',]" @click="jump('A11')" id="A11" ref="A11"></td>
                <td :class="[tileHistory.includes('B11') ? searchedTileClass : '', activeTile.Id == 'B11' ? activeTileClass : '', simpleTileHistory.includes('B11') ? searchedSimpleTileClass : '', endTileHistory.includes('B11') ? searchedEndTileClass : '',]" @click="jump('B11')" id="B11" ref="B11"></td>
                <td :class="[tileHistory.includes('C11') ? searchedTileClass : '', activeTile.Id == 'C11' ? activeTileClass : '', simpleTileHistory.includes('C11') ? searchedSimpleTileClass : '', endTileHistory.includes('C11') ? searchedEndTileClass : '',]" @click="jump('C11')" id="C11" ref="C11"></td>
                <td :class="[tileHistory.includes('D11') ? searchedTileClass : '', activeTile.Id == 'D11' ? activeTileClass : '', simpleTileHistory.includes('D11') ? searchedSimpleTileClass : '', endTileHistory.includes('D11') ? searchedEndTileClass : '',]" @click="jump('D11')" id="D11" ref="D11"></td>
                <td :class="[tileHistory.includes('E11') ? searchedTileClass : '', activeTile.Id == 'E11' ? activeTileClass : '', simpleTileHistory.includes('E11') ? searchedSimpleTileClass : '', endTileHistory.includes('E11') ? searchedEndTileClass : '',]" @click="jump('E11')" id="E11" ref="E11"></td>
                <td :class="[tileHistory.includes('F11') ? searchedTileClass : '', activeTile.Id == 'F11' ? activeTileClass : '', simpleTileHistory.includes('F11') ? searchedSimpleTileClass : '', endTileHistory.includes('F11') ? searchedEndTileClass : '',]" @click="jump('F11')" id="F11" ref="F11"></td>
                <td :class="[tileHistory.includes('G11') ? searchedTileClass : '', activeTile.Id == 'G11' ? activeTileClass : '', simpleTileHistory.includes('G11') ? searchedSimpleTileClass : '', endTileHistory.includes('G11') ? searchedEndTileClass : '',]" @click="jump('G11')" id="G11" ref="G11"></td>
                <td :class="[tileHistory.includes('H11') ? searchedTileClass : '', activeTile.Id == 'H11' ? activeTileClass : '', simpleTileHistory.includes('H11') ? searchedSimpleTileClass : '', endTileHistory.includes('H11') ? searchedEndTileClass : '',]" @click="jump('H11')" id="H11" ref="H11"></td>
                <td :class="[tileHistory.includes('I11') ? searchedTileClass : '', activeTile.Id == 'I11' ? activeTileClass : '', simpleTileHistory.includes('I11') ? searchedSimpleTileClass : '', endTileHistory.includes('I11') ? searchedEndTileClass : '',]" @click="jump('I11')" id="I11" ref="I11"></td>
                <td :class="[tileHistory.includes('J11') ? searchedTileClass : '', activeTile.Id == 'J11' ? activeTileClass : '', simpleTileHistory.includes('J11') ? searchedSimpleTileClass : '', endTileHistory.includes('J11') ? searchedEndTileClass : '',]" @click="jump('J11')" id="J11" ref="J11"></td>
                <td :class="[tileHistory.includes('K11') ? searchedTileClass : '', activeTile.Id == 'K11' ? activeTileClass : '', simpleTileHistory.includes('K11') ? searchedSimpleTileClass : '', endTileHistory.includes('K11') ? searchedEndTileClass : '',]" @click="jump('K11')" id="K11" ref="K11"></td>
              </tr>
              <tr>
                <td :class="[tileHistory.includes('A12') ? searchedTileClass : '', activeTile.Id == 'A12' ? activeTileClass : '', simpleTileHistory.includes('A12') ? searchedSimpleTileClass : '', endTileHistory.includes('A12') ? searchedEndTileClass : '',]" @click="jump('A12')" id="A12" ref="A12"></td>
                <td :class="[tileHistory.includes('B12') ? searchedTileClass : '', activeTile.Id == 'B12' ? activeTileClass : '', simpleTileHistory.includes('B12') ? searchedSimpleTileClass : '', endTileHistory.includes('B12') ? searchedEndTileClass : '',]" @click="jump('B12')" id="B12" ref="B12"></td>
                <td :class="[tileHistory.includes('C12') ? searchedTileClass : '', activeTile.Id == 'C12' ? activeTileClass : '', simpleTileHistory.includes('C12') ? searchedSimpleTileClass : '', endTileHistory.includes('C12') ? searchedEndTileClass : '',]" @click="jump('C12')" id="C12" ref="C12"></td>
                <td :class="[tileHistory.includes('D12') ? searchedTileClass : '', activeTile.Id == 'D12' ? activeTileClass : '', simpleTileHistory.includes('D12') ? searchedSimpleTileClass : '', endTileHistory.includes('D12') ? searchedEndTileClass : '',]" @click="jump('D12')" id="D12" ref="D12"></td>
                <td :class="[tileHistory.includes('E12') ? searchedTileClass : '', activeTile.Id == 'E12' ? activeTileClass : '', simpleTileHistory.includes('E12') ? searchedSimpleTileClass : '', endTileHistory.includes('E12') ? searchedEndTileClass : '',]" @click="jump('E12')" id="E12" ref="E12"></td>
                <td :class="[tileHistory.includes('F12') ? searchedTileClass : '', activeTile.Id == 'F12' ? activeTileClass : '', simpleTileHistory.includes('F12') ? searchedSimpleTileClass : '', endTileHistory.includes('F12') ? searchedEndTileClass : '',]" @click="jump('F12')" id="F12" ref="F12"></td>
                <td :class="[tileHistory.includes('G12') ? searchedTileClass : '', activeTile.Id == 'G12' ? activeTileClass : '', simpleTileHistory.includes('G12') ? searchedSimpleTileClass : '', endTileHistory.includes('G12') ? searchedEndTileClass : '',]" @click="jump('G12')" id="G12" ref="G12"></td>
                <td :class="[tileHistory.includes('H12') ? searchedTileClass : '', activeTile.Id == 'H12' ? activeTileClass : '', simpleTileHistory.includes('H12') ? searchedSimpleTileClass : '', endTileHistory.includes('H12') ? searchedEndTileClass : '',]" @click="jump('H12')" id="H12" ref="H12"></td>
                <td :class="[tileHistory.includes('I12') ? searchedTileClass : '', activeTile.Id == 'I12' ? activeTileClass : '', simpleTileHistory.includes('I12') ? searchedSimpleTileClass : '', endTileHistory.includes('I12') ? searchedEndTileClass : '',]" @click="jump('I12')" id="I12" ref="I12"></td>
                <td :class="[tileHistory.includes('J12') ? searchedTileClass : '', activeTile.Id == 'J12' ? activeTileClass : '', simpleTileHistory.includes('J12') ? searchedSimpleTileClass : '', endTileHistory.includes('J12') ? searchedEndTileClass : '',]" @click="jump('J12')" id="J12" ref="J12"></td>
                <td :class="[tileHistory.includes('K12') ? searchedTileClass : '', activeTile.Id == 'K12' ? activeTileClass : '', simpleTileHistory.includes('K12') ? searchedSimpleTileClass : '', endTileHistory.includes('K12') ? searchedEndTileClass : '',]" @click="jump('K12')" id="K12" ref="K12"></td>
              </tr>
              <tr>
                <td :class="[tileHistory.includes('A13') ? searchedTileClass : '', activeTile.Id == 'A13' ? activeTileClass : '', simpleTileHistory.includes('A13') ? searchedSimpleTileClass : '', endTileHistory.includes('A13') ? searchedEndTileClass : '',]" @click="jump('A13')" id="A13" ref="A13"></td>
                <td :class="[tileHistory.includes('B13') ? searchedTileClass : '', activeTile.Id == 'B13' ? activeTileClass : '', simpleTileHistory.includes('B13') ? searchedSimpleTileClass : '', endTileHistory.includes('B13') ? searchedEndTileClass : '',]" @click="jump('B13')" id="B13" ref="B13"></td>
                <td :class="[tileHistory.includes('C13') ? searchedTileClass : '', activeTile.Id == 'C13' ? activeTileClass : '', simpleTileHistory.includes('C13') ? searchedSimpleTileClass : '', endTileHistory.includes('C13') ? searchedEndTileClass : '',]" @click="jump('C13')" id="C13" ref="C13"></td>
                <td :class="[tileHistory.includes('D13') ? searchedTileClass : '', activeTile.Id == 'D13' ? activeTileClass : '', simpleTileHistory.includes('D13') ? searchedSimpleTileClass : '', endTileHistory.includes('D13') ? searchedEndTileClass : '',]" @click="jump('D13')" id="D13" ref="D13"></td>
                <td :class="[tileHistory.includes('E13') ? searchedTileClass : '', activeTile.Id == 'E13' ? activeTileClass : '', simpleTileHistory.includes('E13') ? searchedSimpleTileClass : '', endTileHistory.includes('E13') ? searchedEndTileClass : '',]" @click="jump('E13')" id="E13" ref="E13"></td>
                <td :class="[tileHistory.includes('F13') ? searchedTileClass : '', activeTile.Id == 'F13' ? activeTileClass : '', simpleTileHistory.includes('F13') ? searchedSimpleTileClass : '', endTileHistory.includes('F13') ? searchedEndTileClass : '',]" @click="jump('F13')" id="F13" ref="F13"></td>
                <td :class="[tileHistory.includes('G13') ? searchedTileClass : '', activeTile.Id == 'G13' ? activeTileClass : '', simpleTileHistory.includes('G13') ? searchedSimpleTileClass : '', endTileHistory.includes('G13') ? searchedEndTileClass : '',]" @click="jump('G13')" id="G13" ref="G13"></td>
                <td :class="[tileHistory.includes('H13') ? searchedTileClass : '', activeTile.Id == 'H13' ? activeTileClass : '', simpleTileHistory.includes('H13') ? searchedSimpleTileClass : '', endTileHistory.includes('H13') ? searchedEndTileClass : '',]" @click="jump('H13')" id="H13" ref="H13"></td>
                <td :class="[tileHistory.includes('I13') ? searchedTileClass : '', activeTile.Id == 'I13' ? activeTileClass : '', simpleTileHistory.includes('I13') ? searchedSimpleTileClass : '', endTileHistory.includes('I13') ? searchedEndTileClass : '',]" @click="jump('I13')" id="I13" ref="I13"></td>
                <td :class="[tileHistory.includes('J13') ? searchedTileClass : '', activeTile.Id == 'J13' ? activeTileClass : '', simpleTileHistory.includes('J13') ? searchedSimpleTileClass : '', endTileHistory.includes('J13') ? searchedEndTileClass : '',]" @click="jump('J13')" id="J13" ref="J13"></td>
                <td :class="[tileHistory.includes('K13') ? searchedTileClass : '', activeTile.Id == 'K13' ? activeTileClass : '', simpleTileHistory.includes('K13') ? searchedSimpleTileClass : '', endTileHistory.includes('K13') ? searchedEndTileClass : '',]" @click="jump('K13')" id="K13" ref="K13"></td>
              </tr>
            </table>
      </v-row>
    </v-col>
    <v-col :cols='[this.$vuetify.breakpoint.smAndDown ? 8 : 6]'>
      <v-row class="text-center" justify="space-around">
        <v-col v-if="activeTile.pill" cols='12'><h1 class="xchangeHeader">{{activeTile.pill}}</h1></v-col>
        <v-col cols='12'>{{activeTile.desc}}</v-col>
        <v-col cols='12'><v-img :src='activeTile.img' max-height='45vh' contain></v-img></v-col>
      </v-row>
    </v-col>
    <v-col cols='2' v-if='!this.activeTile.end && !this.$vuetify.breakpoint.smAndDown'>
      <v-row class="text-center" justify="space-around">
        <v-col cols='12'>
          <v-btn icon color="green" :disabled="!this.activeTile.options.includes('north')" v-on:keyup.38.native="progress('north')" @click="progress('north')">
            <v-icon>mdi-arrow-up-bold</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="text-center" justify="space-around">
        <v-col cols='6'>
          <v-btn icon color="green" :disabled="!this.activeTile.options.includes('west')" v-on:keyup.37.native="progress('west')" @click="progress('west')">
            <v-icon>mdi-arrow-left-bold</v-icon>
          </v-btn>
        </v-col>
        <v-col cols='6'>
          <v-btn icon color="green" :disabled="!this.activeTile.options.includes('east')" v-on:keyup.39.native="progress('east')" @click="progress('east')">
            <v-icon>mdi-arrow-right-bold</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="text-center" justify="space-around">
        <v-col cols='12'>
          <v-btn icon color="green" :disabled="!this.activeTile.options.includes('south')" v-on:keyup.40.native="progress('south')" @click="progress('south')">
            <v-icon>mdi-arrow-down-bold</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols='2' v-if='this.activeTile.end && !this.$vuetify.breakpoint.smAndDown'>
        <v-row class="text-center" justify="space-around">
          <v-col cols='12'>
            <v-btn icon color="green" @click="reset()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
  </v-row>
</template>

<script>
    export default {
      name: 'transformationMaze',
      data: () => ({
        activeTile: {
          Id: 'F13',
          desc: "The XChange Corporation has offered big money for research trials in the past, but nothing like what they're offering for their maze trial. You don't quite know why they're doing it this way, but they say its got something to do with better randomization of test subjects. What makes this research so different is its also a game! The more transformations you pick up, the larger your payment will be at the end! However, every transformation adds 1-7 days to the length of your transformation, and any transformation lasting more than 30 days will be permanent.",
          options: ['north'],
          img: 'https://i.imgur.com/VPromPB.png',
          end: false,
          compensation: 0,
          masculinity: 0
        },
        masculinity: 100,
        transformationDuration: 0,
        transformationPercentage: 0,
        compensation: 50000,
        searchTile: '',
        tileHistory: ["F13"],
        simpleTileHistory: [],
        endTileHistory: [],
        activeTileClass: "activeTileCSS",
        searchedTileClass: "searchedTileCSS",
        searchedSimpleTileClass: "searchedSimpleTileCSS",
        searchedEndTileClass: "searchedEndTileCSS",
        activePill: "",
        tiles:[
          {
            Id: 'F13',
            desc: "The XChange Corporation has offered big money for research trials in the past, but nothing like what they're offering for their maze trial. You don't quite know why they're doing it this way, but they say its got something to do with better randomization of test subjects. What makes this research so different is its also a game! The more transformations you pick up, the larger your payment will be at the end! However, every transformation adds 1-7 days to the length of your transformation, and any transformation lasting more than 30 days will be permanent.",
            options: ['north'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'F12',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['west', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'E12',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['north', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'E11',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['north', 'south'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'E10',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['north', 'south', 'west'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'E9',
            desc: "A dead end! A pill is waiting for you. You take it and feel your body transform into a new woman. A voice over the intercom lets you know that you've taken an experimental new X-Change Oral called X-Change Oral Gamble. The voice explains that every time you suck a cock, it will feel orgasmic, and your transformation durration will either be halved or doubled. You will have no way of knowing until the next day. As always, if the transformation lasts more than a month, it will be permanent. You can circumvent all chance by just not sucking dick, but the urge to do so will get greater and greater as time goes on! You put on the new clothes they've provided you and move on.",
            options: ['south'],
            img: 'https://i.imgur.com/RyhIpyZ.gif',
            end: false,
            compensation: 20000,
            masculinity: -30,
            pill: 'X-Change Oral Gamble'
          },
          {
            Id: 'D10',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['west', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'C10',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['south', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'C11',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['north', 'south'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'C12',
            desc: "You come to a room with a pill on a pedestal and a pair of panties. You take the pill, and your pants are suddenly very tight. You feel the back begin to rip and realize your ass has suddenly grown! You take your pants off, and notice that your dick has also gotten a little smaller. You begrudgingly slide the panties over your new ass and continue your journey.",
            options: ['north', 'west'],
            img: 'https://i.imgur.com/3Q9aAXB.gif',
            end: false,
            compensation: 10000,
            masculinity: -20,
            pill: "X-Change Maximus"
          },
          {
            Id: 'B12',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['east', 'west'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'A12',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['east', 'north'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'A11',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['south', 'north'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'A10',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['south', 'north'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'A9',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['south', 'north'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'A8',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['south', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'B8',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['west', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'C8',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['north', 'west'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'C7',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['north', 'south'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'C6',
            desc: "You reached a dead end! In front of you is a pill. You take it, and feel your body start to transform. Then you feel a sudden sharp stinging, and close your eyes tightly in pain. When you open them, you're looking at a beautiful woman. But to your confusion, that beautiful woman is you, looking at another beautiful woman. An intercom explains you've just taken a new experimental pill, X-Change Pisces. You have been transformed into two women, and the lab wants to take notes on the sensations you both feel simultaneously during sex. You will be given a room at the lab, and will be spending the remainder of your life testing Pisces with yourself.",
            options: [],
            img: 'https://i.imgur.com/1Rq50Om.gif',
            end: true,
            compensation: 250000,
            masculinity: -100,
            pill: "X-Change Pisces"

          },
          {
            Id: 'G12',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['east', 'west'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'H12',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['east', 'west'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'I12',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['east', 'west', 'north'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'I11',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['north', 'south'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'I10',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['south', 'west'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'H10',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['east', 'west'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'G10',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['north', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'G9',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['north', 'south'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'G8',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['north', 'south', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'H8',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['west', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'I8',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['north', 'west'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'I7',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['south', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'J7',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['west', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'K7',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['west', 'north'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'K6',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['south', 'north'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'K5',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['south', 'north', 'west'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'J5',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['east', 'west'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'I5',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['east', 'north'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'I4',
            desc: "A pill is waiting for you, as well as some lingerie. You take the pill, and as you start to grow tits, you suddenly feel the skin on your chest get extremely tight as they begin to fill with silicone. A voice over the intercom lets you know you've been given X-Change Purple Bimbo. Your lips swell, your ass perks up, and before you know it, all you can think about is shopping, getting your nails done, and sucking cock. The good news is you're keeping your dick, the better news is you've been given an enormous sum of money to help support your new bimbo lifestyle!",
            options: ['west', 'south'],
            img: 'https://i.imgur.com/4CgjBiR.mp4',
            end: false,
            compensation: 500000,
            masculinity: -80,
            pill: "X-Change Purple Bimbo"
          },
          {
            Id: 'H4',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['west', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'G4',
            desc: "As you enter a dead end, you are greeted with a pill. You take it and feel tits quickly grow. Your dick shrinks and retreats into your body until you can feel a pussy where it used to be. You try to focus on the changes that are happening still, but all you can think about is how badly you want to fuck someone. The intercom explains you've just taken an X-Chanage Nympho. For the next year, you will be living in the X-Change dorms, paired with someone who has taken an X-Change Nympho blue. The researchers want to see if the two of you can have enough sex to make the other not want any more. Good thing you can't get pregnant with this one, you're about to be fucking an awful lot!",
            options: [],
            img: 'https://i.imgur.com/fQaHmGa.gif',
            end: true,
            compensation: 50000,
            masculinity: -100,
            pill: 'X-Change Nympho'
          },
          {
            Id: 'K4',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['south', 'north'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'K3',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['south', 'north'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'K2',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['south', 'west'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'J2',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['west', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'I2',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['west', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'H2',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['west', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'G2',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['west', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'F2',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['west', 'east', 'north'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'E2',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['south', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'E3',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['north', 'south', 'west'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'D3',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['east', 'west'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'C3',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['north', 'south', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'C4',
            desc: "As you enter a dead end, you see a pill and a butt plug. You take the pill and feel your body changing into the shape of a new woman. A voice over the intercom lets you know this pill is an experimental new paired pill. You have to put the plug in your ass and keep it there for the duration of your transformation, or the transformation will be permanent. The plug can only be removed for up to 3 hours a day for cleaning. You don't want to be a woman forever, so you put on the new clothes they've provided for you, lube up your ass, and stick the plug in. To your surprise, its much more comfortable than you expected.",
            options: ['north'],
            img: 'https://i.imgur.com/JbCByTI.gif',
            end: false,
            compensation: 50000,
            masculinity: -40,
            pill: 'X-Change Pair Plug'
          },
          {
            Id: 'C2',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['south', 'west'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'B2',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['east', 'west'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'A2',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['south', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'A3',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['south', 'north'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'A4',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['south', 'north'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'A5',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['south', 'north'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'A6',
            desc: "You hit a dead end! A pill is waiting for you, as well as some lingerie. You take the pill, and as your penis disappears, and you start to grow tits, you suddenly feel the skin on your chest get extremely tight as they begin to fill with silicone. A voice over the intercom lets you know you've been given X-Change Bimbo. Your lips swell, your ass perks up, and before you know it, all you can think about is shopping, getting your nails done, and sucking cock. The bad news is this is permanent, the good news is you've been given an enormous sum of money to help support your new bimbo lifestyle!",
            options: [],
            img: 'https://i.imgur.com/xZzNyau.gif',
            end: true,
            compensation: 1000000,
            masculinity: -100,
            pill: 'X-Change Bimbo'
          },
          {
            Id: 'E4',
            desc: "You hit a dead end, and see a pill in the middle of the room. You take the pill, and as your penis shinks and you start to grow tits, you suddenly feel the skin on your chest get extremely tight as they begin to fill with silicone. A voice over the incom lets you know that you have just taken X-Change Double D. Essentially, a standard X-Change pink, but you've been given pretty large tits. You slip into some clothes the lab has provided for you and continue on your journey.",
            options: ['north'],
            img: 'https://i.imgur.com/TNJJUjw.gif',
            end: false,
            compensation: 20000,
            masculinity: -30,
            pill: 'X-Change Double D'
          },
          {
            Id: 'G7',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['north', 'south'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'G6',
            desc: "As you enter a dead end, you see a pill and a butt plug. You take the pill and feel your body changing into the shape of a new woman, save for a little remnant of your old manhood between your legs. A voice over the intercom lets you know this pill is an experimental new paired pill. You have to put the plug in your ass and keep it there for the duration of your transformation, or the transformation will be permanent. The plug can only be removed for up to 3 hours a day for cleaning. You don't want to be a woman forever, so you put on the new clothes they've provided for you, lube up your ass, and stick the plug in. To your surprise, its much more comfortable than you expected.",
            options: ['west', 'south'],
            img: 'https://i.imgur.com/oVgdlO1.gif',
            end: false,
            compensation: 20000,
            masculinity: -20,
            pill: "X-Change Purple Paired Plug"
          },
          {
            Id: 'F6',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['west', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'E6',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['south', 'east'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'E7',
            desc: "A dead end! A pill is in front of you, and you take it. You feel your dick shrink until its inside of your body, but you don't feel any real sensation in your new pussy. A voice over the intercom tell you that you've just taken an X-Change Sissy Pink. Like the normal sissy pill, you can only orgasm from anal, but researchers want to see if it will stil work without a prostate. You will be testing in the lab for the next month, and then you're free to spend your money however you please in your new life!",
            options: [],
            img: 'https://i.imgur.com/PUedV3D.gif',
            end: true,
            compensation: 150000,
            masculinity: -100,
            pill: 'X-Change Sissy Pink'
          },
          {
            Id: 'J12',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['east', 'west'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'K12',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['north', 'west'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'K11',
            desc: "Ahead of you, you see a pill and a chastity cage. You take the pill and feel your body changing into the shape of a new woman, but you are keeping a small semblance of your manhood in the form of a tiny dick between your legs. A voice over the intercom lets you know this pill is an experimental new paired pill. You have to put the cage on and keep it on for the duration of your transformation, or the transformation will be permanent. The cage can only be removed for up to 1 hour a day for cleaning. You don't want to be a woman forever, so you put on the new clothes they've provided for you, grab your tiny dick, and lock it away. To your surprise, its much more comfortable than you expected.",
            options: ['north', 'south'],
            img: 'https://i.imgur.com/hw8vJ9R.gif',
            end: false,
            compensation: 5000,
            masculinity: -10,
            pill: 'X-Change Purple Pair'
          },
          {
            Id: 'K10',
            desc: "You progress in the maze, but see nothing of interest in this area.",
            options: ['north', 'south'],
            img: 'https://i.imgur.com/VPromPB.png',
            end: false,
            compensation: 0,
            masculinity: 0
          },
          {
            Id: 'K9',
            desc: "You reached a dead end! In front of you is a pill. You take it, and feel your clothes suddenly grow! You wonder to yourself, \"how did they do that\" After a few seconds, you realize your clothes aren't getting bigger, you're getting smaller! Two men walk in and explain you've just taken a new experimental pill, X-Change Mini. You'll spend the rest of your life as a petite woman, and they have been sent in to test your new body's durability. They assure you that after a month of daily testing, you'll recieve your compensation and can being living your new life!",
            options: [],
            img: 'https://i.imgur.com/4PshT5x.gif',
            end: true,
            compensation: 150000,
            masculinity: -100,
            pill: "X-Change Mini"
          },
          {
            Id: 'F1',
            desc: "Great work! You managed to make it to the exit without having to take any pills! Enjoy your money, X-Change Laboratories thanks you for you service today.",
            options: [],
            img: 'https://i.imgur.com/VPromPB.png',
            end: true,
            compensation: 0,
            masculinity: 0
          },
        ],
        alphabet: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]
      }),
      methods: {
        progress(direction){
          let activeID = this.activeTile.Id.split('');
          if(activeID.length == 3){
            activeID[1] += activeID [2];
            activeID.splice(2, 1);
          }
          let letterIndex = this.alphabet.indexOf(activeID[0]);
          if(direction == 'west') {
            letterIndex--;
            activeID[0] = this.alphabet[letterIndex];
          } else if (direction == 'east') {
            letterIndex++;
            activeID[0] = this.alphabet[letterIndex];
          } else if (direction == 'north') {
            activeID[1]--;
          } else {
            activeID[1]++;
          }
          this.activeTile = this.tiles.find(tile => tile.Id == activeID.join(''));
          if(this.activeTile.masculinity < 0 && this.activeTile.masculinity > -100){
            this.transformationDuration += (Math.floor(Math.random() * 7) + 1);
          }
          if(this.activeTile.masculinity == -100){
            this.transformationDuration = 30;
          }
          if(this.transformationDuration > 0){
            this.transformationPercentage = (this.transformationDuration/30) * 100;
          }
          this.masculinity += this.activeTile.masculinity;
          this.compensation += this.activeTile.compensation;
          if(this.masculinity < 0) {
            this.masculinity = 0;
          }
          if(this.masculinity > 100) {
            this.masculinity = 100;
          }
          if(!this.tileHistory.includes(this.activeTile.Id) || !this.simpleTileHistory.includes(this.activeTile.Id) || !this.endTileHistory.includes(this.activeTile.Id)){
            if(this.activeTile.end){
              this.endTileHistory.push(this.activeTile.Id);
            } else if(this.activeTile.masculinity < 0){
              this.simpleTileHistory.push(this.activeTile.Id);
            } else {
              this.tileHistory.push(this.activeTile.Id);
            }
          }
          if(this.activeTile.pill){
            this.activePill = this.activeTile.pill;
          }
          if(this.activeTile.Id == 'F1'){
            if(this.activePill != ''){
              this.activeTile.desc = "Great work! You've reached the exit of the maze! You will be under the effects of " + this.activePill + " for a total of " + this.transformationDuration + " days and will be walking away with $" + this.compensation + "! Remember the rules of your pill if you want any hope of ever changing back!";
              console.log(this.activePill + 'img :');
              console.log(this.tiles.find(tile => tile.pill == this.activePill).img);
              this.activeTile.img = this.tiles.find(tile => tile.pill == this.activePill).img;
            }
          }
        },
        reset(){
          this.activeTile = this.tiles.find(tile => tile.Id == 'F13');
          this.masculinity = 100;
          this.compensation = 50000;
          this.transformationPercentage = 0;
          this.transformationDuration = 0;
          this.searchTile = '';
        },
        search(){
          this.activeTile = this.tiles.find(tile => tile.Id == this.searchTile.toUpperCase());
        },
        jump(tileId){
          if(this.masculinity != 0){
            if(this.tileHistory.includes(tileId)){
              this.activeTile = this.tiles.find(tile => tile.Id == tileId);
            }
            if(this.activeTile.masculinity < 0 && this.activeTile.masculinity > -100){
              this.transformationDuration += (Math.floor(Math.random() * 7) + 1);
            }
            if(this.activeTile.masculinity == -100){
              this.transformationDuration = 30;
            }
            if(this.transformationDuration > 0){
              this.transformationPercentage = (this.transformationDuration/30) * 100;
            }
            this.masculinity += this.activeTile.masculinity;
            this.compensation += this.activeTile.compensation;
            if(this.masculinity < 0) {
              this.masculinity = 0;
            }
            if(this.masculinity > 100) {
              this.masculinity = 100;
            }
          }
        }
      },
    }
</script>

<style scoped>
  @font-face {
    font-family: "XChangeFont";
    src: local("XChangeFont"),
     url(../../assets/xchangeFont.TTF) format("truetype");
  }

  .xchangeHeader{
    font-family: "XChangeFont";
    -webkit-text-stroke: 1px #ff879c;
    -webkit-text-fill-color: white;
    text-shadow: 2px 2px 3px #000;
  }

  table, th, td {
    border: 1px solid black !important;
  }

  td {
    height: 15px;
  }

  .activeTileCSS {
    background-color: blue !important;
  }

  .searchedTileCSS {
    background-color: grey;
  }

  .searchedSimpleTileCSS {
    background-color: pink;
  }

  .searchedEndTileCSS {
    background-color: red;
  }
  </style>